module.exports = __webpack_public_path__ + "img/thumbnail_AlpineGoat_f_leucistic.177ca300.png";